<template lang="pug">
  section.faq-hero
    h1.faq-hero__heading.heading.heading--1 {{ heading }}
</template>

<script>
  export default {
    name: 'FaqHero',
    props: {
      heading: String,
    },
  };
</script>

<style lang="scss">
  .faq-hero__heading {
    text-align: left;
    padding: $spacing-unit * 10 $spacing-unit * 2;

    @include tablet-up {
      padding-bottom: 0;
    }
  }
</style>
